// This file was auto-generated by querybuilder/Apollo and should not be edited.

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL fragment: OnboardingScaffolding
// ====================================================

export interface OnboardingScaffolding {
  firstName: string;
  lastName: string;
  preferredFirstName: string;
  street: string;
  city: string;
  isCityInNyc: boolean | null;
  /**
   * Whether the onboarding user is in Los Angeles County. If we don't have enough information to tell, this will be null.
   */
  isInLosAngeles: boolean | null;
  state: string;
  borough: string;
  zipCode: string;
  aptNumber: string | null;
  email: string;
  phoneNumber: string;
  leaseType: string;
  receivesPublicAssistance: boolean | null;
  hasLandlordEmailAddress: boolean | null;
  hasLandlordMailingAddress: boolean | null;
  canReceiveRttcComms: boolean | null;
  canReceiveSajeComms: boolean | null;
}

export const BlankOnboardingScaffolding: OnboardingScaffolding = {
  "firstName": "",
  "lastName": "",
  "preferredFirstName": "",
  "street": "",
  "city": "",
  "isCityInNyc": null,
  "isInLosAngeles": null,
  "state": "",
  "borough": "",
  "zipCode": "",
  "aptNumber": null,
  "email": "",
  "phoneNumber": "",
  "leaseType": "",
  "receivesPublicAssistance": null,
  "hasLandlordEmailAddress": null,
  "hasLandlordMailingAddress": null,
  "canReceiveRttcComms": null,
  "canReceiveSajeComms": null
};

export const graphQL = `# This file was auto-generated by querybuilder, please do not edit it.
fragment OnboardingScaffolding on OnboardingScaffolding {
  firstName,
  lastName,
  preferredFirstName,
  street,
  city,
  isCityInNyc,
  isInLosAngeles,
  state,
  borough,
  zipCode,
  aptNumber,
  email,
  phoneNumber,
  leaseType,
  receivesPublicAssistance,
  hasLandlordEmailAddress,
  hasLandlordMailingAddress,
  canReceiveRttcComms,
  canReceiveSajeComms
}`;